//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Storage from '@tencent/vft-common/Storage';
var SAVE_KEY = 'ysf_live_show_time';
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    close: function close() {
      this.$emit('input', false);
      this.$emit('close');
    }
  },
  computed: {
    liveTimeLineItem: function liveTimeLineItem() {
      return window.setting.时间线[1];
    }
  },
  created: function created() {
    var page = this.page,
        now = this.now;
    var time = Storage.get(SAVE_KEY);

    if (time && +time + 10 * 60 * 1000 > now) {
      return;
    }

    var _ref = this.liveTimeLineItem || {},
        开始时间 = _ref.开始时间,
        结束时间 = _ref.结束时间; // 第1场


    if (now >= 开始时间 && now <= 结束时间 && page !== 'live' && page !== 'pay') {
      this.eventBus.$emit('showLivePop');
      Storage.set(SAVE_KEY, Date.now());
    }
  }
};